export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryQSR/theme/components/scorecard/MetricsLabels/index.js